import React from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '../components/pagelayout';
import './accessDenied.css';

export default function AccessDenied() {
  return (
    <PageLayout activePage="scheduling">
      <div className="accessDeniedPage">
        <div className="lockCard">
          <div className="lockIcon">🔒</div>
        </div>

        <h1>You don't have access</h1>
        <h3>This page is protected</h3>
        <p>
          It seems you don't have the necessary permissions to access this content
        </p>

        <Link to="/Home" className="returnBtn"> Return to Dashboard
        </Link>

        <div className="accessInfoCard">
          <h2>Need Access?</h2>
          <p>
            Contact the system administrator to request the required permissions
          </p>

          <div className="accessInfoGrid">
            <div className="accessInfoBox">
              <span>Error Code</span>
              <strong>403</strong>
            </div>

            <div className="accessInfoBox">
              <span>Page</span>
              <strong>Protected</strong>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}